
import request from '@/router/axios';

export const getTrainingDetail = (params) => request({
    url: '/api/mcc-staff/processtrain/detail',
    method: 'get',
    params: {
      ...params
    },
  })